export class DtoWBE {
    ID_WBE: number = 0;
    CodigoWBE: string = '';
    DescripcionWBE: string = '';
}